import { ArrowRight, Calendar, Filter, Search } from "react-feather";
import styles from "./notificationfilter.module.css";
import { Link } from "react-router-dom";
import { useState } from "react";
import { DateRangePicker } from "rsuite";

const NotificationFilter = ({ setFilterData }) => {
    const [filterOpen, setFilterOpen] = useState(false);

    return <div className={`${styles.NotesSearchArea}`}>
        <div className={`${styles.FilterSearchSec}`}>
            <div className={`${styles.NotesSearchMain}`}>
                <Search />
                <input type="text" placeholder="Search" className={`${styles.searchInput}`} onChange={(e) => setFilterData((prev) => { return { ...prev, searchKey: e.target.value }; })} />
            </div>
        </div>
        <div className={`${styles.FilterSec}`}>
            <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
                <p className={`${styles.FilterTitle}`}>
                    Filters
                    <span onClick={(e) => setFilterOpen(false)}><ArrowRight /></span>
                </p>
                <div className={`${styles.FilterCard} ${styles.Width200} Filter`}>
                    <div className={`${styles.DashFilterSec} DashFilterSec`}>
                        <DateRangePicker
                            format={"M/d/yy"}
                            placeholder={"Filter by date"}
                            placement={"bottomEnd"}
                            caretAs={Calendar}
                            showOneCalendar
                            onChange={(e) =>
                                setFilterData((prev) => {
                                    return { ...prev, date: e };
                                })
                            }
                        />
                    </div>
                </div>
            </div>
            <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
                <Filter />
            </Link>
        </div>
    </div>;
}

export default NotificationFilter;